import { createEntityTouchSelect } from './helpers/createEntityTouchSelect';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';

export type SelectableSupplierLocationPair = QueryHookResult<
  typeof useSupplierLocationPairQuery
>[number];

export const useSupplierLocationPairQuery = createQueryHook(
  'shared.selectSupplierLocationPair',
  (params: { searchTerm?: string; ids?: string[] }) => ({
    accountAddresses: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
          isSupplier: true,
          searchByAccountName: true,
        },
        pagination: {
          offset: 0,
          limit: 50,
        },
      },
      entries: {
        id: true,
        accountId: true,
        name: true,
        locationType: true,
        address: {
          streetAddress: true,
          city: true,
          state: true,
          postalCode: true,
          country: true,
        },
        account: {
          name: true,
        },
      },
    },
  }),
  {
    select: (data) => data?.accountAddresses.entries ?? [],
  },
);

interface SupplierEntityProps {
  address: {
    streetAddress: string | null;
    city: string | null;
    state: string | null;
    postalCode: string | null;
  };
}

export const formatSupplierAddress = (entity: SupplierEntityProps): string => {
  const parts = [
    entity.address.streetAddress,
    entity.address.city,
    entity.address.state,
    entity.address.postalCode,
  ].filter(Boolean);

  return parts.join(', ') || 'No address';
};

export const SelectSupplierLocationPairTouch =
  createEntityTouchSelect.remotelySearched(
    'SelectSupplierLocationPair',
    useSupplierLocationPairQuery,
    {
      formatLabel: (entity) =>
        (entity.account?.name ?? 'Unknown') +
        (entity.name ? ' — ' + entity.name : ''),
      formatSubLabel: (entity) => formatSupplierAddress(entity),
    },
  );
